import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/config";

const links = [
  { id: "conteudo", label: "Conteúdo" },
  { id: "para-quem", label: "Para quem" },
  { id: "faq", label: "FAQ" },
];

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="26" cy="32" r="17" fill="#0A192F" />
    <circle cx="43" cy="32" r="11" fill="#ea580c" />
  </svg>
);

export default function Header() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-navy/5 bg-sand/85 backdrop-blur-md">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 md:px-12">
        <button
          data-testid="logo-home-button"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="flex items-center gap-2.5"
        >
          <LogoMark />
          <span className="font-display text-lg font-bold tracking-tight">
            Autismo <span className="text-flame">+</span> Cuidados
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-bold text-ink transition-colors duration-200 hover:text-navy"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="header-buy-button"
            onClick={() => go("comprar")}
            className="group inline-flex items-center gap-1.5 rounded-full bg-navy px-6 py-3 text-sm font-extrabold text-white transition-all duration-200 hover:scale-[1.03] hover:bg-flame"
          >
            Quero o e-book
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </nav>

        <button
          data-testid="mobile-menu-button"
          className="md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-navy/5 bg-sand px-6 pb-6 pt-2 md:hidden">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full py-3 text-left text-base font-bold text-navy"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-header-buy-button"
            onClick={() => go("comprar")}
            className="mt-2 w-full rounded-full bg-flame px-6 py-3.5 text-sm font-extrabold text-white"
          >
            Quero o e-book
          </button>
        </div>
      )}
    </header>
  );
}
